import { type SVGProps } from 'react';

const ArrowIcon = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7339_42374)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.18195 0.830365C7.98341 0.168296 6.56655 0.831033 6.24241 2.13247C6.0237 3.01058 5.81007 4.13022 5.67907 5.42568H2.57126C1.1511 5.42568 -0.000173569 6.57695 -0.000173569 7.99711C-0.000173569 9.41727 1.1511 10.5685 2.57126 10.5685H5.6785C5.80944 11.8664 6.02338 12.9881 6.24241 13.8674C6.56655 15.1689 7.98341 15.8317 9.18195 15.1696C11.9642 13.6327 14.3706 10.992 15.6203 9.20167C16.1266 8.47626 16.1266 7.52368 15.6203 6.79828C14.3706 5.00793 11.9642 2.36726 9.18195 0.830365Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_7339_42374">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { ArrowIcon };
